__turbopack_context__.v({
  "availabilityMessage": "application-link-module-scss-module__S0nDPq__availabilityMessage",
  "availabilityMessageClosed": "application-link-module-scss-module__S0nDPq__availabilityMessageClosed",
  "availabilityMessageOpen": "application-link-module-scss-module__S0nDPq__availabilityMessageOpen",
  "buttonWrapper": "application-link-module-scss-module__S0nDPq__buttonWrapper",
});
